import React from 'react';

import { UploadDocumentV3 } from 'components/common/media';
import InstaTaskUploadDocument from './InstaTaskUploadDocument';

const InstaTaskSideBarItemFiles = ({
  files,
  isLoading,
  uploadDocumentWithType = false,
  documentsType = [],
  onChange,
  onDelete,
  onSubmitDocumentWithType,
}) => {
  return (
    <UploadDocumentV3
      enableUpload={false}
      documents={files}
      onChange={onChange}
      onDeleteDocument={onDelete}
      loading={isLoading}
      UploadComponent={
        uploadDocumentWithType ? (
          <InstaTaskUploadDocument
            documentsType={documentsType}
            onSubmit={onSubmitDocumentWithType}
            isLoading={isLoading}
          />
        ) : null
      }
    />
  );
};

export default InstaTaskSideBarItemFiles;
